import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeItemGroupCreate,
  detail: routeItemGroupDetail,
  home: routeItemGroupsHome,
  root: routeItemGroupsRoot,
} = createDoctypeRoutes({
  createName: 'new-item-group',
  createPath: 'new-item-group',
  detailName: 'itemGroupDetail',
  doctype: DOCTYPES.ITEM_GROUP,
  homeName: 'item-groups',
  path: 'item-groups',
  views: {
    create: async () => await import('@/components/viewsExternal/itemGroups/AddItemGroup.vue'),
    detail: async () => await import('@/components/viewsExternal/itemGroups/ViewItemGroup.vue'),
    list: async () => await import('@/components/viewsExternal/itemsModule/ViewItems.vue'),
  },
})

export { routeItemGroupCreate, routeItemGroupDetail, routeItemGroupsHome, routeItemGroupsRoot }
